import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'rutChilenoDv'
})
export class RutChilenoDvPipe implements PipeTransform {

  transform(value: string | number): string {
    if (!value) return ''; // Si no hay valor, retorna vacío

    // Eliminar cualquier carácter que no sea número
    let rut = value.toString().replace(/\D/g, '');
    let dv = rut.slice(-1); // Extraer el dígito verificador
    let cuerpo = rut.slice(0, -1); // Obtener la parte numérica

    // Insertar puntos cada tres dígitos desde la derecha
    let formatted = cuerpo.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

    // Retornar el RUT formateado con guion y dígito verificador
    return `${formatted}-${dv}`;
  }

}
